import Head from "next/head";

interface IProps {
  title: string;
  description: string;
  favicon?: string;
}
const PageHead = (props: IProps) => {
  const {title, description, favicon} = props

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description}/>
      {favicon && <link rel="shortcut icon" href={favicon}/>}
    </Head>
  )
}

export default PageHead